import * as React from 'react';

import { Layer } from 'bernie-view';
import { QueryRoute } from 'bernie-core';

import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { UitkDialogContent, UitkFullscreenDialog } from 'uitk-react-dialog';

export const TermsAndConditionsDialog = ({ action, routeStore }) => {
  const closeAction = () => {
    routeStore.goBack();
  };

  return (
    <QueryRoute query={{ pwaDialog: 'couponTerms' }}>
      <Layer id="coupon-terms" onDismiss={closeAction}>
        <UitkFullscreenDialog strictFullscreen={true}>
          <UitkToolbar header="More about this offer" iconLabel="Close the dialog" action={closeAction} type={ToolbarType.CLOSE} />
          <UitkDialogContent>
            <div className="uitk-grid">
              <div className="uitk-cell all-cell-1-6" />
              <div className="uitk-cell all-cell-2-3">
                <div className="all-y-margin-three">
                  <p>{action.actionDetails.details}</p>
                </div>
              </div>
              <div className="uitk-cell all-cell-1-6" />
            </div>
          </UitkDialogContent>
        </UitkFullscreenDialog>
      </Layer>
    </QueryRoute>
  );
};
